import classNames from 'classnames';
import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import styles from './TeamIcon.module.scss';
import usePublicOrganization from './usePublicOrganization';

interface TeamIconProps {
  size?: 'small' | 'regular' | 'medium' | 'large' | 'xlarge';
}

const TeamIcon = ({ size = 'regular' }: TeamIconProps) => {
  const sessionOrg = useAppSelector((state) => state.session.organization);
  const publicOrg = usePublicOrganization();

  const organization = sessionOrg.id ? sessionOrg : publicOrg;
  const { name } = organization;
  const logo = organization?.logo?.thumb || null;

  const classes = classNames(styles.teamIconDefault, {
    [styles.small]: size === 'small',
    [styles.regular]: size === 'regular',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.xlarge]: size === 'xlarge',
    [styles.withBackground]: logo === null,
  });

  return logo ? (
    <span className={classes} style={{ backgroundImage: `url(${logo})` }} />
  ) : (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    <span className={classes}>{name && name[0]!.toUpperCase()}</span>
  );
};

export default TeamIcon;
